import * as React from 'react';

import { humanizeLearningTime } from 'js/utils/DateTimeUtils';

import TimeCommitmentEffortText from 'bundles/learner-progress/components/item/TimeCommitmentEffortText';
import type { Item } from 'bundles/learner-progress/types/Item';
import { getIsReviewPartForSplitPeer } from 'bundles/learner-progress/utils/Item';

/**
 * @param timeCommitment
 * @returns string, intended for use for aria-label etc. See EffortTextV2 to render a React element.
 */
export const getEffortTextV2 = (computedItem: Item): string | undefined => {
  if (getIsReviewPartForSplitPeer(computedItem)) {
    return undefined;
  }

  if (computedItem.timeCommitment) {
    return humanizeLearningTime(computedItem.timeCommitment);
  }

  return undefined;
};

type Props = {
  computedItem: Item;
};

/* Slimmed-down version of static/bundles/learner-progress/components/item/EffortText.tsx */
const EffortTextV2 = ({ computedItem, ...rest }: Props) => {
  if (getIsReviewPartForSplitPeer(computedItem)) {
    return null;
  }

  return <TimeCommitmentEffortText timeCommitment={computedItem.timeCommitment} {...rest} />;
};

export default EffortTextV2;
